import React, { useState, useEffect } from "react";
import Loading from "../../components/customcomponents/loading";
import Layout from "../../components/include/layout";
import { useParams } from "react-router";
import { getBlogCategoryComponent } from "../../data/api";
import Error from "../../components/pages/404error";
import Widthcontainer from "../../components/customcomponents/widthcontainer";
import BlogPostCard from "../components/BlogPostCard";
import SideBar from "../components/SideBar.js";
import MobileDropdown from "../components/MobileDropdown.js";
import ReactLoading from "react-loading";
import SeoTags from "../../utils/seoTags";

function BlogCategory() {
   const params = useParams();
   const { id } = params;
   const [categoryId, setCategoryId] = useState(id);
   const [loading, setLoading] = useState(true);
   const [blogLoading, setBlogLoading] = useState(false);
   const [error, setError] = useState(false);
   const [currentCategory, setCurrentCategory] = useState({});
   const [otherCategory, setOtherCategory] = useState([]);
   const [blogs, setBlogs] = useState([]);
   const [featuredBlogs, setFeaturedBlogs] = useState([]);

   useEffect(() => {
      async function getData() {
         otherCategory?.length == 0 && setLoading(true);
         const response = await getBlogCategoryComponent(categoryId);
         if (response.status !== 200) setError(true);
         otherCategory?.length > 0 && setBlogLoading(true);
         setCurrentCategory(response?.data?.currentCategory);
         setOtherCategory(response?.data?.otherCategory);
         setBlogs(response?.data?.blogPost);
         setFeaturedBlogs(response?.data?.featuredBlogs);
         setLoading(false);
         setBlogLoading(false);
      }
      getData();
   }, [categoryId, id]);
   return error ? (
      <Error />
   ) : (
      <Layout footer={"blog"}>
         {loading ? (
            <Loading />
         ) : (
            <>
               {SeoTags(`${currentCategory?.title} | DishHome Blog`)}
               <Widthcontainer className={"blogCategory__Heading"}>
                  <p className="headingText">{currentCategory?.title}</p>
               </Widthcontainer>
               <Widthcontainer className={"blogCategory__content__container"}>
                  <div className="fixed-width blogCategory__content__wrapper">
                     <MobileDropdown
                        currentCategory={currentCategory}
                        categories={otherCategory}
                        setCategoryId={setCategoryId}
                     />
                     {blogLoading ? (
                        <div
                           className="d-flex align-items-center justify-content-center"
                           style={{ flex: "1" }}
                        >
                           <ReactLoading type="cylon" color="#ed1c24" height={305} width={305} />
                        </div>
                     ) : (
                        <div className="blogCategory__content__wrapper__blog">
                           {Object.entries(blogs)?.map(([key, value]) => {
                              return <BlogPostCard data={value} />;
                           })}
                        </div>
                     )}
                     <SideBar
                        setCategoryId={setCategoryId}
                        featuredBlogs={featuredBlogs}
                        currentCategory={currentCategory}
                        otherCategory={otherCategory}
                     />
                  </div>
               </Widthcontainer>
            </>
         )}
      </Layout>
   );
}

export default BlogCategory;
